/**
 * 文字列または数値を数値に変換して返す
 * @param value - 数値に変換する値。
 * @returns 変換された数値（入力が有効な数値でない場合は0）
 */
export const toNumber = (value: string | number): number => {
  if (typeof value === 'number') return value;
  const parsed = parseInt(value, 10);
  return Number.isNaN(parsed) ? 0 : parsed;
};
